import React, { useCallback } from 'react';
import CustomTextField from '../DriverPopUp/common/CustomTextField';
import { getShortenedListItemsLabel } from '../../../../common/utils';
import { withStyles } from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

const styles = (theme) => ({
  wrapper: {
    width: '100%'
  },
  fullWidth: {
    width: '100%',
    margin: 0
  }
});

const InputBox = ({ classes, onClick, label, optionSelected, persistentLabelText }) => {
  const getSelectedDisplayText = useCallback(() => {
    if (persistentLabelText) {
      return persistentLabelText;
    }
    return getShortenedListItemsLabel({
      items: optionSelected?.map((item) => item.label),
      showCount: 3
    });
  }, [optionSelected, persistentLabelText]);

  const selectedDisplayText = getSelectedDisplayText();
  const labelText = persistentLabelText ? null : label;

  return (
    <div className={classes.wrapper}>
      <CustomTextField
        label={labelText}
        className={classes.fullWidth}
        classes={{
          inputRoot: classes.inputRoot,
          inputField: classes.inputField
        }}
        id={`CustomMultiSelectorInput-${label}`}
        value={selectedDisplayText}
        endAdornment={<ExpandMoreIcon />}
        onClick={onClick}
        hideClearIcon
        readOnly
      />
    </div>
  );
};

export default withStyles(styles)(InputBox);
